/* ============
 * Supplier Index
 * ============
 *
 * This page shows the list of Bills.
 */
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import warehouseService from './../../../../services/warehouse';
import accountService from './../../../../services/account';
import debounce from 'debounce';
import SearchMixin from './../../../../mixins/search';
import BridgeHandoffMixin from './../../../../mixins/bridgeHandoff';

export default {
  data() {
    return {
      loading: true,
      sortValue: '',
      limit: 25,
    };
  },

  computed: {
    ...mapGetters({
      warehouses: 'paginateWarehouses',
    }),

    warehousesList() {
      return this.warehouses.items.map(b =>
        /* let cardClass = '';

         if (b.billStatus === 'Overdue') {
           cardClass = 'card-red';
         } else if (b.billStatus === 'Cleared') {
           cardClass = 'card-green';
         } else if (b.billStatus === 'Sent') {
           cardClass = 'card-yellow';
         }

         Object.assign(b, {
           number: b.billingNumber ? `#${b.billingNumber}` : 'Draft',
           value: `${b.totalValue.toFixed(2)} NOK`,
           amount: `(${b.totalQuantity} ${this.$t('static.bills.index.quantities')})`,
           dueDateFormated: moment(b.dueDate).isValid() ? moment(b.dueDate).format('DD-MM-YYYY') : '-',
           cardClass,
         });*/

         b);
    },
  },

  watch: {
    /**
     * Listem to router changes, used to check query params that have changed to apply filters.
     *
     * @param  {Object} route Current route object.
     */
    $route() {
      this.all(1, this.limit);
    },
  },

  components: {
    VCard: require('./../../../../components/card/card.vue'),
    VPagination: require('./../../../../components/paginationNew/paginationNew.vue'),
    VNoData: require('./../../../../components/noData/noData.vue'),
  },

  mixins: [
    SearchMixin,
    BridgeHandoffMixin,
  ],

  mounted() {
    this.setInnerSidebar([{
      title: this.$t('static.inventory.transaction.title'),
      options: [{
        title: this.$t('static.stock.filters.title'),
        route: {
          name: 'inventory.stock.index',
        },
      },
      {
        title: this.$t('static.adjustment.filters.title'),
        route: {
          name: 'inventory.adjustment.index',
        },
      },
      {
        title: this.$t('static.purchase.filters.title'),
        route: {
          name: 'inventory.purchase.index',
        },
      },
      {
        title: this.$t('static.transfer.filters.title'),
        route: {
          name: 'inventory.transfer.index',
        },
      },
      ],
      button: this.bridgeStockWriteBlocked ? null : {
        title: `+ ${this.$t('static.warehouse.addTransaction.title')}`,
        route: {
          name: 'inventory.transaction.index',
        },
      },
    },
    {
      title: this.$t('static.warehouse.filters.title'),
      options: [{
        title: 'Active', // this.$t('static.warehouse.filters.view'),
        route: {
          name: 'warehouse.index',
          query: {
            filter: 'active',
          },
        },
      },
      {
        title: 'In-Active',
        route: {
          name: 'warehouse.index',
          query: {
            filter: 'inActive',
          },
        },
      }],
      button: {
        title: `+ ${this.$t('static.warehouse.create.title')}`,
        route: {
          name: 'warehouse.create',
        },
      },
    },
    ]);

    accountService.rememberPerPage('get', { from: 'warehouse' })
    .then((data) => {
      this.limit = data.size;
      this.all(1, this.limit);
    }).catch((error) => {
      console.log(error);
    });
  },

  destroyed() {
    this.unsetInnerSidebar();
  },

  methods: {
    ...mapMutations({
      setInnerSidebar: 'SET_INNERSIDEBAR',
      unsetInnerSidebar: 'UNSET_INNERSIDEBAR',
    }),

    perPage(size) {
      accountService.rememberPerPage('post', { from: 'warehouse', perPage: size })
      .then((data) => {
        this.limit = data.size;
      }).catch((error) => {
        console.log(error);
      });
    },

    /**
     * Fetches paginated warehouse.
     *
     * @param  {int} page The page number.
     * @param  {int} limit The number of items displayed on a page.
     */
    all: debounce(function (page, limit) {
      this.loading = true;
      warehouseService.items({
        page,
        limit,
        search: this.getSearch(this.limit),
        filter: this.$route.query.filter,
      }).then(() => {
        this.loading = false;
      }).catch(() => {
        this.loadProductsing = false;
      });
    }, 800),

    /**
     * Go to edit view for warehouse.
     *
     * @param  {Object} warehouse The warehouse object.
     */
    editWarehouse(warehouse) {
      const name = 'warehouse.edit';
      this.$router.push({
        name,
        params: { id: warehouse.id },
      });
    },

    /**
     * Go to edit view for warehouse on new tab.
     *
     * @param  {Object} warehouse The warehouse object.
     */
    editWarehouseNewTab(warehouse) {
      const name = 'warehouse.edit';
      const route = this.$router.resolve({
        name,
        params: { id: warehouse.id },
      });
      window.open(route.href, '_blank');
    },

    returnWarehouseType(warehouseTypeName, isBonded) {
      const isBondedText = isBonded ? this.$t('static.warehouse.info.isBonded') : this.$t('static.warehouse.info.notBonded');
      return `${warehouseTypeName} ${isBondedText}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/warehouse/index/index.js